import React from 'react';
import * as FIUser from '../data/FIUser.js';
import { MainView, TextInput, UserIcon, Button} from '../components/components.js';

class Settings extends React.Component {


	constructor(props) {
		super(props);

		this.saveClick = this.saveClick.bind(this);
		this.handleInputUpdate = this.handleInputUpdate.bind(this);

		window._fiUser.loadSessionInfo();
		window._fiSponsor.loadSessionInfo();

		this.state = { 
			FirstNameField : window._fiUser.firstname, 
			LastNameField : window._fiUser.lastname,
			EmailField : window._fiUser.email,
			JobTitleField : window._fiUser.job_title,
			CurrentPWField : '',
			NewPWField : '',
			ConfPWField : '',
			PasswordError : false
		};
	}

	async saveClick(e) {
		const currentHash = await FIUser.sha512(this.state.CurrentPWField);

		if (this.state.NewPWField.length) {
			var errorMessage = false;
			if (currentHash !== window._fiUser.hashPass) {
				errorMessage = 'Current Password Incorrect';
			}
			else if (this.state.NewPWField !== this.state.ConfPWField) {
				errorMessage = 'New Passwords do not match';
			}
			else if (this.state.NewPWField.length < 8) {
				errorMessage = 'Password must be at least 8 characters';
			}
			else if (this.state.NewPWField.match(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[-+_!@#$%^&*.,?\=])/g) == null) {
				errorMessage = "Password must contain at least:<br /><ul><li>one upper-case & one lower-case letter</li><li>one number</li><li>one non-alphanumeric character</li></ul>";
			}

			if (errorMessage) {
				console.log(errorMessage);
				this.setState({PasswordError : errorMessage});
				return;
			}
		}
		var component = this;

		window._fiUser.firstname = this.state.FirstNameField;
		window._fiUser.lastname = this.state.LastNameField;
		window._fiUser.email = this.state.EmailField;
		window._fiUser.job_title = this.state.JobTitleField;

		var callback = function(response) {
			if(response.code === 200) {
				window._fiUser.hashPass = FIUser.sha512(component.state.NewPWField);
				window._fiUser.saveSessionInfo();
			}
		}

		window._fiUser.UPDATE(callback, this.state.NewPWField);
	}

	handleInputUpdate(value, dataId) {
	    var stateObj = {};
	    stateObj[dataId] = value;
	    this.setState(stateObj)
	  }

	render() {
		if(!window._fiSponsor.sponsors.length) {
			window._fiSponsor.loadSessionInfo();
		}
		var content = (
			<div className='User-Settings'>
				<UserIcon accessLevel={window._fiUser.role} />
				<div className='User-Settings-Name'>{window._fiUser.firstname + ' ' + window._fiUser.lastname}</div>
				<div className='User-Settings-Title'>{window._fiUser.job_title}</div>
				<div className='User-Settings-Fields'>
					<TextInput dataId='FirstNameField' class='User-Settings-Input' handleChange={this.handleInputUpdate} placeholder='first name' value={this.state.FirstNameField} />
					<TextInput dataId='LastNameField' class='User-Settings-Input' handleChange={this.handleInputUpdate} placeholder='last name' value={this.state.LastNameField} />
					<TextInput dataId='EmailField' class='User-Settings-Input' handleChange={this.handleInputUpdate} placeholder='email' value={this.state.EmailField} />
					<TextInput dataId='JobTitleField' class='User-Settings-Input' handleChange={this.handleInputUpdate} placeholder='job title' value={this.state.JobTitleField} />
					<TextInput dataId='CurrentPWField' class='User-Settings-Input' handleChange={this.handleInputUpdate} placeholder='current password' value={this.state.CurrentPWField} type="password" error_str={this.state.PasswordError} />
					<TextInput dataId='NewPWField' class='User-Settings-Input' handleChange={this.handleInputUpdate} placeholder='new password' value={this.state.NewPWField} type="password"/>
					<TextInput dataId='ConfPWField' class='User-Settings-Input' handleChange={this.handleInputUpdate} placeholder='confirm password' value={this.state.ConfPWField} type="password" />
				</div>
				<Button class="App-Button" dataId="settingssave" label="Save" onClick={this.saveClick} />
			</div>
			);

		return (
			<MainView location="Settings" amount={window._fiSponsor.sponsors[0].total_saved} content={content} />
		);
  	}
}


export default Settings;